import { Fragment, useEffect, useRef, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import storage from '@/utils/storage';
import { LoadingSpinner } from '@/components/SpinnerOverlay';
import { ApiGetPrivacyPolicy } from '@/features/homepage/api/ApiGetTermAndPolicyInfo';
import { Button } from 'antd';
import { COMPANY_CODE } from '@/constant';
import { cond } from 'lodash';

// SCN07

const PrivacyPolicyPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [policyTextCommon, setPolicyTextCommon] = useState("");
    const [policyEdeliveryText, setPolicyEdeliveryText] = useState("");
    const [policyDoorStepText, setPolicyDoorStepText] = useState("");
    const policyPageTitle = '使用規約一覧は以下の通りです';

    // Fetch privacy policy content on mount
    useEffect(() => {
        const my_company_code = storage.getVkorg();
        const fetchData = async () => {
            try {
                const res = await ApiGetPrivacyPolicy();
                if (res) {

                    const policy_common = res.find(x => x.policy_cd == "1" && x.VKORG == my_company_code) ? res.find(x => x.policy_cd == "1" && x.VKORG == my_company_code) : res.find(x => x.policy_cd == "1" && x.VKORG == COMPANY_CODE.CCBJI);
                    const policy_edelivery = res.find(x => x.policy_cd == "2" && x.VKORG == my_company_code) ? res.find(x => x.policy_cd == "2" && x.VKORG == my_company_code) : res.find(x => x.policy_cd == "2" && x.VKORG == COMPANY_CODE.CCBJI);
                    const policy_door_step = res.find(x => x.policy_cd == "3" && x.VKORG == my_company_code) ? res.find(x => x.policy_cd == "3" && x.VKORG == my_company_code) : res.find(x => x.policy_cd == "3" && x.VKORG == COMPANY_CODE.CCBJI);

                    setPolicyTextCommon(policy_common ? policy_common.html_content : "");
                    setPolicyEdeliveryText(policy_edelivery ? policy_edelivery.html_content : "");
                    setPolicyDoorStepText(policy_door_step ? policy_door_step.html_content : "");
                    setLoading(false)
                }
            } catch (error) {
                    setPolicyTextCommon("");
                    setPolicyEdeliveryText("");
                    setPolicyDoorStepText("");
            }

        }
        fetchData();
    }, [navigate]);

    // Handler: Go back to home page
    const backToHomePage = () => {
        navigate('/');
    }

    // Handler: Open external privacy policy page in new tab
    const goToPrivacyPolicy = () => {
        window.open('https://www.ccbj-holdings.com/policy/privacy.php');
    }

    // Show spinner while loading
    if (loading == true) {
        return <LoadingSpinner />;
    }

    // Main privacy policy page UI
    return (
        <Fragment>
            <ol className="breadcrumb">
                <li className="breadcrumb-item active">
                    <NavLink to="/"><u>ホーム</u></NavLink>
                </li>
                <li className="breadcrumb-item active">使用規約</li>
            </ol>
            <div className="jumbotron">
                <div className="section">
                    <div className="card-body" style={{ minHeight: '80vh' }}>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">
                                <div>
                                    <div style={{ fontSize: '16px', textAlign: 'center' }}><strong>{policyPageTitle}</strong></div>
                                    <br></br>
                                    <div className="policyTextCommon" dangerouslySetInnerHTML={{ __html: policyTextCommon }}>
                                    </div>
                                    <div className="policyEdeliveryText" dangerouslySetInnerHTML={{ __html: policyEdeliveryText }}>
                                    </div>
                                    <div className="policyDoorStepText" dangerouslySetInnerHTML={{ __html: policyDoorStepText }}>
                                    </div>
                                    <div className="d-flex justify-content-center ">
                                        <a role="link" tabIndex={0} className="text-primary link-home text-center" style={{ cursor: 'pointer' }} onClick={goToPrivacyPolicy}><u>プライバシーポリシーはコチラ</u></a>
                                    </div>
                                    <br />
                                </div>
                                <div className="d-flex justify-content-center ">
                                    <Button className="btn bg-discard col-md-3 col-sm-6 m-2" style={{ fontSize: '14px', height: '40px' }} onClick={backToHomePage}>
                                        <span className='text-white' >戻る</span>
                                    </Button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </Fragment>
    )
};

export default PrivacyPolicyPage;